import { Material } from "../../products/material";
import { Category } from "../category";

export class CategoryProduct {
    product?: Material;
    category?: Category;
}
